import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const Trello = lazy(() => import('../../container/project/Trello/getboard'));
const TrelloGetboard = lazy(() => import('../../container/project/Trello/getlist'));
const Asana = lazy(() => import('../../container/project/Asana/getprojects'));
const AsanaGetTask = lazy(() => import('../../container/project/Asana/gettasks'));
const AsanaCreateProject = lazy(() => import('../../container/project/Asana/createproject'));

function ProjectRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/asana/getproject`} component={Asana} />
      <Route path={`${path}/asana/gettask/:projectId`} component={AsanaGetTask} />
      <Route path={`${path}/asana/createproject`} component={AsanaCreateProject} />
      <Route path={`${path}/trello/getboard`} component={Trello} />
      <Route path={`${path}/trello/getlist/:boardId`} component={TrelloGetboard} />
    </Switch>
  );
}

export default ProjectRoutes;
